import React, { useState } from 'react';

import UsersApi from '../../../Api/CRM/Modules/UsersApi';
import User from '../../../Api/Models/User';
import Card from '../../elements/common/Card';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

import UserForm, { emptyUser } from './UserForm';

function UserEdit() {
    const { id } = useNumberParams();
    const [user, setUser] = useState<User>(emptyUser);

    useOnce(() => UsersApi.getById(id, false).then(setUser));

    return (
        <Card title="Update user">
            <UserForm action={() => UsersApi.update(user)} user={user} setUser={setUser} />
        </Card>
    );
}

export default UserEdit;
